module.exports = __webpack_public_path__ + "static/media/1-NN-Klapp.f586f571.mp3";